import ResultByQuestion, { ResultByQuestionProps } from './ResultByQuestion';

export default ResultByQuestion;
export type { ResultByQuestionProps };
